import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=3404c82c&"
import script from "CJ/components/leftMenu.component?vue&type=script&lang=js&"
export * from "CJ/components/leftMenu.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports